var render = function render(){
  var _vm$primaryKey, _vm$items;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "data-test": "outside-vif"
    }
  }, [_vm.totalItems > 0 && !_vm.isBusy && !_vm.hidePagerTotal && !_vm.hideAllPages ? _c('div', {
    staticClass: "base-table-pager-total"
  }, [_vm._t("pager-total", function () {
    return [_vm._v("\n      Displaying " + _vm._s(_vm.displayingCurrent) + " - " + _vm._s(_vm.displayingCurrentTotal) + " of\n      "), _c('strong', [_vm._v(_vm._s(_vm.totalItems))]), _vm._v(" results\n    ")];
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "base-table-wrapper"
  }, [_c('br', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b-table', {
    key: (_vm$primaryKey = _vm.primaryKey) !== null && _vm$primaryKey !== void 0 ? _vm$primaryKey : (_vm$items = _vm.items) === null || _vm$items === void 0 ? void 0 : _vm$items.length,
    ref: "table",
    class: _vm.tableClasses,
    attrs: {
      "striped": "",
      "hover": "",
      "sticky-header": true,
      "no-local-sorting": _vm.noLocalSorting,
      "no-sort-reset": true,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "show-empty": "",
      "busy": _vm.isBusy,
      "items": _vm.items,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.noProviderPaging ? _vm.itemsPerPage : 0,
      "no-provider-paging": _vm.noProviderPaging,
      "id": _vm.tableId,
      "primary-key": _vm.primaryKey,
      "table-class": _vm.tableClasses,
      "caption-html": _vm.tableCaption,
      "caption-top": _vm.tableCaptionAbove
    },
    on: {
      "update:sortBy": function ($event) {
        _vm.sortBy = $event;
      },
      "update:sort-by": function ($event) {
        _vm.sortBy = $event;
      },
      "update:sortDesc": function ($event) {
        _vm.sortDesc = $event;
      },
      "update:sort-desc": function ($event) {
        _vm.sortDesc = $event;
      },
      "sort-changed": _vm.sortingChangedEvent
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function () {
        return [_vm._t("table-busy", function () {
          return [_c('raft-busy', {
            attrs: {
              "busy-text": "Loading..."
            }
          })];
        })];
      },
      proxy: true
    }, {
      key: "empty",
      fn: function () {
        return [_vm._t("empty", function () {
          return [_c('div', {
            class: _vm.classPrefix + '-empty-text'
          }, [_vm._v("\n            There are currently no items to list.\n          ")])];
        })];
      },
      proxy: true
    }, {
      key: "head()",
      fn: function (data) {
        return [_vm.customHeaders.includes(data.column) ? _c('div', [_vm._t(_vm.customHeaderSlotName(data.column), null, {
          "data": data
        })], 2) : _vm._e()];
      }
    }, {
      key: "cell()",
      fn: function (data) {
        var _data$value;
        return [data !== null && data !== void 0 && (_data$value = data.value) !== null && _data$value !== void 0 && _data$value.v_html ? _c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.getHtmlCell(data.value))
          }
        }) : data.value.custom_slot ? _c('div', [_vm._t(data.value.custom_slot, null, {
          "data": data
        })], 2) : data.field.custom_slot ? _c('div', [_vm._t(data.field.custom_slot, null, {
          "data": data
        })], 2) : _c('div', [_vm._v("\n          " + _vm._s(data.value) + "\n        ")])];
      }
    }], null, true)
  }), _vm._v(" "), _vm.totalItems > _vm.itemsPerPage && !_vm.hideAllPages ? _c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalItems,
      "per-page": _vm.itemsPerPage,
      "aria-controls": _vm.tableId,
      "limit": "10",
      "first-text": "« first",
      "prev-text": "‹ previous",
      "next-text": "next ›",
      "last-text": "last »",
      "align": "center"
    },
    model: {
      value: _vm.selectedPage,
      callback: function ($$v) {
        _vm.selectedPage = $$v;
      },
      expression: "selectedPage"
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("extra")], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }